export const getSeverityColor = (severity?: string): string => {
    if (!severity) return 'inherit'
    const value = severity.toLowerCase()
    if (value.includes('critical')) return '#DC0202'
    if (value.includes('warning')) return '#B38A04'
    return 'inherit'
}

export const stripTimeFromMessage = (message?: string): string => {
    if (!message) return ''
    return message
        .replace(/\s+(on|at)\s+\d{1,2}\/\d{1,2}\/\d{4}.*$/i, '')
        .trim()
}

export const getStatusIconPath = (
    status: number,
    severity?: string,
): string => {
    let suffix = 'unread'
    if (status === 1) suffix = 'read'
    if (status === 2) suffix = 'ignore'

    let prefix = 'normal'
    const sevLower = severity?.toLowerCase() || ''
    if (sevLower.includes('critical')) prefix = 'critical'
    else if (sevLower.includes('warning')) prefix = 'warning'
    else if (sevLower.includes('info')) prefix = 'info'

    return `/assets/images/icons/notification_status/${prefix}_${suffix}.svg`
}

export const getStatusTooltipText = (
    status: number,
    severity?: string,
    t: (key: string) => string = (s: string) => s,
): string => {
    let cleanSeverity = 'Normal'
    const sevLower = severity?.toLowerCase() || ''
    if (sevLower.includes('critical')) cleanSeverity = t('critical')
    else if (sevLower.includes('warning')) cleanSeverity = t('warning')
    else if (sevLower.includes('info')) cleanSeverity = t('info')
    else cleanSeverity = t('Normal')

    if (status === 1) return `${cleanSeverity} ${t('read')}`
    if (status === 2) return `${cleanSeverity} ${t('Ignore')}`
    return cleanSeverity
}
